export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** ApplicationError represents an application-level error that occurred during request processing. */
export type ApplicationError = {
  __typename?: 'ApplicationError';
  /** The error code indicating the type of application error that occurred. */
  code: ApplicationErrorCode;
  /** A human-readable message describing the application error. */
  message: Scalars['String']['output'];
};

/** ApplicationErrorCode enumerates the possible types of application errors. */
export enum ApplicationErrorCode {
  /** Indicates the caller provided invalid input. */
  BadRequest = 'BAD_REQUEST',
  /**
   * Indicates the request conflicts with the current state of the resource, such
   * as a stale revision or an idempotency key reused with different input.
   */
  Conflict = 'CONFLICT',
  /** Indicates the caller does not have permission to perform the requested operation. */
  Forbidden = 'FORBIDDEN',
  /** Indicates the requested resource was not found. */
  NotFound = 'NOT_FOUND',
  /** Indicates an overage spend limit (org or per-user) would be exceeded. */
  OverageLimitReached = 'OVERAGE_LIMIT_REACHED',
  /** Indicates the request or one of its parts exceeds a size limit. */
  PayloadTooLarge = 'PAYLOAD_TOO_LARGE',
  /** Indicates the caller is not authorized to perform the requested operation. */
  Unauthorized = 'UNAUTHORIZED'
}

/** InternalServerError represents an internal server error that occurred during request processing. */
export type InternalServerError = {
  __typename?: 'InternalServerError';
  /** A human-readable message describing the internal server error. */
  message: Scalars['String']['output'];
};

/** InternalServerErrorCode enumerates the possible types of internal server errors. */
export enum InternalServerErrorCode {
  /** Indicates the server timed out waiting for an action or request to complete. */
  ServerTimedOut = 'SERVER_TIMED_OUT',
  /** Indicates an unknown internal server error occurred. */
  Unknown = 'UNKNOWN'
}

/** ValidationError represents a validation error that occurred during input validation. */
export type ValidationError = {
  __typename?: 'ValidationError';
  /** The validation error code indicating the type of validation failure. */
  code: ValidationErrorCode;
  /**
   * An array of field paths indicating which fields failed validation.
   * For nested fields, each path segment is an element in the array.
   */
  field: Array<Scalars['String']['output']>;
  /** A human-readable message describing the validation error. */
  message: Scalars['String']['output'];
};

/** ValidationErrorCode enumerates the possible types of validation errors. */
export enum ValidationErrorCode {
  /**
   * Indicates the field was changed by someone else since the caller read it, and the
   * two changes could not be reconciled. The caller has to see what landed before the
   * field can be saved again.
   */
  Conflict = 'CONFLICT',
  /** Indicates a field's value was invalid according to validation rules. */
  Invalid = 'INVALID',
  /** Indicates a required field was missing or empty. */
  Required = 'REQUIRED'
}
